export const ID68 = () => {
    return (
        <div className="section__tab" id="opisanie_vozmozhnostey_i_printsipov_raboty" >
            <div className="about-card__title">
                Описание возможностей и принципов работы
            </div>
            <p >
                Программный продукт предназначен&nbsp;для предприятий использующих автотранспорт в
                производственно-хозяйственной деятельности. Позволяет организовать работу диспетчера, механика,
                расчетчика зарплаты водителей, таксировщика путевых листов и т.д. Реализует процессы планирования и
                учета работы транспортных средств, их обслуживания и ремонтов, учета затрат.
            </p>
            Программный продукт&nbsp;представляет собой самостоятельное решение, разработанное с использованием <i>1С:Библиотеки
            стандартных подсистем</i>, <i>ред. 2.4.</i> <br/>
            <br/>
            Для использования&nbsp;программного продукта совместно с&nbsp;1С:Бухгалтерия для Казахстана&nbsp;рекомендуем
            использовать интегрированный программный продукт <a href="https://1c-rating.kz/sol/Buhtranscom"
                                                                target="_blank"><span
            >1С-Рейтинг: Бухгалтерия автотранспортного предприятия</span></a><br/>
            <br/>
            <h3>Назначение</h3>
            <ul>
                <li > Управление парком машин:
                    <ul >
                        <li>Опциональное ведение учета машин в разрезе автопарков и автомобильных колонн;</li>
                        <li>Закрепление водителей за транспортными средствами;</li>
                        <li> Учет и контроль актуальности разрешительной документации транспортных средств;</li>
                    </ul>
                </li>
                <li >Планирование работ и диспетчеризация:
                    <ul >
                        <li> Учет заказов на выполнение транспортных работ, заказов на внутреннее перемещение машин
                            между парками;
                        </li>
                        <li>Формирование разнарядок на работу транспорта;</li>
                        <li>Автоматическое формирование путевых листов по данным разнарядок;</li>
                        <li> Рабочее место диспетчера;</li>
                        <li>&nbsp; Учет доступности транспортных средств (учет сходов с линии на ремонт, занятости на
                            выполнении работ);
                        </li>
                        <li>Ведение перечня регулярных транспортных маршрутов;</li>
                    </ul>
                </li>
                <li > Учет выполненных работ и документация:
                    <ul >
                        <li> Учет путевых листов и их состояния (с момента выписки до сдачи и окончательного расчета);
                        </li>
                        <li>Возможность ввода ТТН;</li>
                        <li>Учет выполнения работ в разрезе видов транспортных услуг;</li>
                    </ul>
                </li>
                <li > Управление ремонтами и обслуживание (планирование и учет):
                    <ul >
                        <li>Планирование требуемых ремонтов и ТО (периодических и зависящих от выработки);</li>
                        <li>&nbsp; Учет сроков фактического проведения ремонтов и ТО;</li>
                        <li>Ведение дефектных ведомостей и заявок на ремонт машины;</li>
                        <li> Учет расхода материалов на ремонт машины, заявки на материалы;</li>
                        <li>Ведение ремонтных листов с возможностью учета выполненных ремонтов и видов обслуживания,
                            учета рабочего времени ремонтников;
                        </li>
                        <li> Учет установленных комплектующих (шин и аккумуляторов) и их выработки</li>
                    </ul>
                </li>
                <li >Учет ГСМ:
                    <ul >
                        <li>Учет выдачи ГСМ путевыми листами и заправочными ведомостями;</li>
                        <li> Заправка ГСМ со склада;</li>
                        <li> Заправка ГСМ по талонам (учет выданных талонов, гашение по мере заправки, контроль
                            непогашенных талонов на руках у водителей);
                        </li>
                        <li> Заправка ГСМ по смарт-картам (литровым и денежным, учет движения смарт-карт, заявки на
                            пополнение и учет фактической заправки);
                        </li>
                        <li> Заправка ГСМ за наличные (планирование и выдача денежных средств в подотчет, учет
                            фактической заправки);
                        </li>
                        <li> Настройка формул нормативного расхода ГСМ для списания (как топлива, так и прочих ГСМ),
                            учет пережога топлива;
                        </li>
                        <li>Возможность ограничения возможных к заправке марок топлива по машинам или маркам;</li>
                        <li> Использование одновременно нескольких видов топлива (например, для газобензинового
                            оборудования);
                        </li>
                        <li>Настройка и применение поправочных коэффициентов к расходу топлива;</li>
                    </ul>
                </li>
                <li >Оперативный складской учет:
                    <ul >
                        <li>Возможность ведения оперативного складского учета на складах ГСМ, запчастей и
                            комплектующих;
                        </li>
                        <li>Учет бывших в употреблении комплектующих (шин и аккумуляторов), возвращенных на склад;</li>
                    </ul>
                </li>
                <li >Расчет заработной платы механизаторов и ремонтников:
                    <ul >
                        <li>Расчет зарплаты водителей на основании путевых листов, в зависимости от часовых тарифных
                            ставок, тарифов за управление транспортным средством, повременно (в разрезе видов времени);
                        </li>
                        <li> Расчет зарплаты рабочих, занятых в ремонте транспорта, по данным ремонтных листов;</li>
                    </ul>
                </li>
                <li > Тарификация и расчеты с заказчиками;</li>
                <li >Управление затратами на выполнение работ, содержание и обслуживание:
                    <ul >
                        <li>Возможность ведения управленческого учета затрат;</li>
                        <li>Учет затрат на ГСМ на основании путевых листов и заправочных ведомостей. Возможность
                            установки норм расхода, настройки формул расчета ГСМ;
                        </li>
                        <li>Расчет себестоимости выполненных работ в разрезе транспортных средств, колонн и парков;</li>
                        <li>Учет стоимости обслуживания и владения транспортным средством в разрезе единиц техники, на
                            основании затрат на материалы, ремонты, ГСМ, заработную плату и т.д.;
                        </li>
                    </ul>
                </li>
            </ul>
            <ul>
            </ul>
        </div>
    )
}